<template>
  <div
    class="Polaris-Banner  Polaris-Banner--withinPage my-2"
    :class="{
      'Polaris-Banner--statusCritical': type === 'critical',
      'Polaris-Banner--statusWarning': type === 'warning'
    }"
    tabindex="0"
    role="alert"
    aria-live="polite"
  >
    <div
      class="Polaris-Box"
      style="--pc-box-padding-inline-end-xs:var(--p-space-4)"
    >
      <span
        class="Polaris-Icon Polaris-Icon--colorCritical Polaris-Icon--applyColor"
        :class="{
          'Polaris-Icon--colorCritical': type === 'critical',
          'Polaris-Icon--colorWarning': type === 'warning'
        }"
      >
        <span class="Polaris-Text--root Polaris-Text--visuallyHidden"> </span>
        <svg
          viewBox="0 0 20 20"
          class="Polaris-Icon__Svg"
          focusable="false"
          aria-hidden="true"
        >
          <path
            d="M11.768.768a2.5 2.5 0 0 0-3.536 0l-7.464 7.464a2.5 2.5 0 0 0 0 3.536l7.464 7.464a2.5 2.5 0 0 0 3.536 0l7.464-7.464a2.5 2.5 0 0 0 0-3.536l-7.464-7.464zm-2.768 5.232a1 1 0 1 1 2 0v4a1 1 0 1 1-2 0v-4zm2 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
          ></path>
        </svg>
      </span>
    </div>
    <div class="Polaris-Banner__ContentWrapper">
      <h2 class="Polaris-Text--root Polaris-Text--headingMd">
        <span>{{ type === "warning" ? "Warning" : "Error" }}</span>
      </h2>
      <div
        class="Polaris-Box"
        style="--pc-box-padding-block-end-xs:var(--p-space-05);--pc-box-padding-block-start-xs:var(--p-space-05)"
      >
        <p>
          {{ text }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: { type: String },
    type: { type: String, default: "crtical" }
  }
};
</script>

<style></style>
